export const DEFAULT_QUERY_RETRY = 3;
